import { RouteConfig } from 'vue-router';
const CepingReport = () => import('./views/ceping-report.vue');
const CepingBidui = () => import('./views/ceping-bidui.vue');
const routers: RouteConfig[] = [
    {
        path: 'ceping-report',
        name: 'ceping-report',
        component: CepingReport
    },
    {
        path: 'ceping-bidui',
        name: 'ceping-bidui',
        component: CepingBidui
    },
    {
        path: '*',
        redirect: 'ceping-report'
    },
];
export default routers;

